$shm_hitalama_process_logs $mol_view
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_view
					sub / \Process logs
		^ empty_visible / <= Empty $mol_view
			sub / \No process runs yet
		<= List $mol_list
			sub <= rows /
	Row* $shm_hitalama_process_logs_row
		process <= process* null
